import { AxiosError } from 'axios';

/**
 * A map of ignored API status codes.
 */
export const ignoredApiStatusCodes: Record<number, boolean> = {
  // 401: true, // Example
};

/**
 * A map of ignored API error codes.
 */
export const ignoredApiErrorCodes: Record<string, boolean> = {
  // leave_post_overlap: true, // Example
};

/**
 * Captures a Sentry exception if the error code is not ignored.
 */
export const isInSentryExceptionsAllowList = (error: AxiosError): boolean => {
  const errorCode = (error.response?.data as { code?: string })?.code;
  const statusCode = error.response?.status;
  return !!(
    (errorCode && ignoredApiErrorCodes[errorCode])
    || (statusCode && ignoredApiStatusCodes[statusCode])
  );
};
